import React, { useContext, useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { getAllPointOfInterestsByUser, createPointOfInterest, removePointOfInterest } from '../models/actions/PointOfInterest';
import '../App.css';
import compose from 'recompose/compose';
import SpText from '../components/atoms/SpText';
import SpTextInput from '../components/atoms/SpTextInput';
import SpButton from '../components/atoms/SpButton';
import { styled } from '../components/styled';
import { Grid, TableCell } from '@material-ui/core';
import { withSnackbar } from '../components/atoms/SpSnackBar';
import SpDialog from '../components/atoms/SpDialog';
import Geocode from 'react-geocode';
import SpGoogleMap from '../components/bundles/SpGoogleMap';
import CustomPOIMapMarker from '../components/atoms/CustomPOIMapMarker';
import ReactPlayer from 'react-player';
import { theme } from '../components/theme';
import { UserSessionContext } from '../App';

//Setting up geocode
Geocode.setApiKey('AIzaSyC0KvC-l9aD8fS42m3aVZytFL893tMCw4A');
Geocode.setLanguage('it');
Geocode.setRegion('it');

const PointOfInterest = (props) => {
  const [pointOfInterestList, setPointOfInterestList] = useState([]);
  const [displayPointOfInterest, setDisplayPointOfInterest] = useState([]);
  const [openPointEdit, setOpenPointEdit] = useState({ status: false, data: null });
  const [openDeletePointOfInterest, setOpenDeletePointOfInterest] = useState(false);
  const [currentVideoURL, setCurrentVideoURL] = useState('');
  const [markerClicked, setMarkerClicked] = useState('');
  const [error, setError] = useState(null);
  const { authData, setAuthData } = useContext(UserSessionContext);

  const { register, handleSubmit, control, setValue, getValues, reset } = useForm({
    name: 'pointOfInterest',
    defaultValue: {
      description: '',
      lat: '',
      lng: '',
      title: '',
      video_url: ''
    }
  });

  const fetchData = async () => {
    props.isLoading(true);
    try {
      const response = await getAllPointOfInterestsByUser({ id_user: authData.userId }, authData.accessToken);
      response && setPointOfInterestList(response);
      response && setDisplayPointOfInterest(response);
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
    props.isLoading(false);
  };

  const handleCreatePointOfInterest = async (data) => {
    try {
      const userID = authData.userId;
      let requestData = { ...data };
      console.log(data);
      if (!requestData.lat && !requestData.lng) {
        setError("C'è stato un errore nel recupero della posizone, ripetere la scelta della posizione nella mappa");
      } else {
        setError(null);
        const resultCreation = await createPointOfInterest({ pointOfInterest: { ...requestData, id_user: userID } }, authData.accessToken);
        if (resultCreation) {
          props.snackbarShowMessage(resultCreation.message);
          fetchData();
          setOpenPointEdit({ status: false, data: null });
        }
      }
    } catch (error) {
      props.snackbarShowMessage(error);
    }
  };

  const removePointOfInterestById = async (stationId) => {
    try {
      let response = await removePointOfInterest({ id_point_of_interest: stationId }, authData.accessToken);
      response && fetchData();
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  const handleMarkerClicked = (marker) => {
    console.log(marker);
    setCurrentVideoURL(marker.video_url);
    setMarkerClicked(marker);
    setOpenPointEdit({ status: true, data: marker });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!openPointEdit.status) {
      reset({});
      setCurrentVideoURL('');
      setMarkerClicked(null);
    }
  }, [openPointEdit]);

  useEffect(() => {
    reset({ ...markerClicked });
  }, [markerClicked]);

  const handlePositionChose = (dataFromMap) => {
    reset({ ...getValues(), lat: dataFromMap.lat, lng: dataFromMap.lng });
    setOpenPointEdit({ status: true, data: null });
  };

  const TitleToolbarSection = styled('div')({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  });

  return (
    <>
      <Grid
        container
        style={{ paddingLeft: '1%' }}
        direction="column"
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <TitleToolbarSection>
            <SpText
              variant="h1"
              style={{ marginRight: '5px' }}
            >{`PUNTI DI INTERESSE`}</SpText>
            <SpText
              variant="h4"
              style={{ marginRight: '5px' }}
            >{`Scegli la posizione del punto di interesse scegliendo dove vuoi posizionarlo nella mappa qui sotto`}</SpText>
          </TitleToolbarSection>
        </Grid>
        <SpGoogleMap
          markers={pointOfInterestList}
          CustomMarker={CustomPOIMapMarker}
          handleMarkerClicked={handleMarkerClicked}
          onClick={handlePositionChose}
        />
      </Grid>
      <SpDialog
        style={{ padding: '1%' }}
        open={openDeletePointOfInterest}
        setOpen={setOpenDeletePointOfInterest}
        title={'Elimina stazione'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{'Sei sicuro di voler eliminare il punto di interesse?'}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'SI'}
                buttonType="accept"
                onClick={() => removeStationById(true)}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'NO'}
                buttonType="accept"
                onClick={() => setOpenDeletePointOfInterest(false)}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
      <SpDialog
        style={{ padding: '1%' }}
        open={openPointEdit.status}
        setOpen={setOpenPointEdit}
        title={'Crea o modifica punto di interesse'}
      >
        <form onSubmit={handleSubmit(handleCreatePointOfInterest)}>
          <Grid
            container
            direction="column"
            spacing={2}
          >
            <Grid
              item
              xs={12}
            >
              <SpTextInput
                inputRef={register}
                name="title"
                label="Titolo"
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <SpTextInput
                inputRef={register}
                name="description"
                label="Descrizione"
              />
            </Grid>
            {/* <Grid item xs={12}>
							<SpTextInput inputRef={register} name='region' label='Regione' />
						</Grid>
						<Grid item xs={12}>
							<SpTextInput inputRef={register} name='province' label='Provincia' />
						</Grid>
						<Grid item xs={12}>
							<SpTextInput inputRef={register} name='city' label='Città' />
						</Grid>
						<Grid item xs={12}>
							<SpTextInput inputRef={register} name='street' label='Via' />
						</Grid>
						<Grid item xs={12}>
							<SpTextInput inputRef={register} name='address' label='N. civico' />
						</Grid>
						<Grid item xs={12}>
							<SpTextInput inputRef={register} name='cap' label='CAP' />
							</Grid> */}
            <div style={{ display: 'none' }}>
              <Grid
                item
                xs={12}
              >
                <SpTextInput
                  enabled={false}
                  inputRef={register}
                  name="lng"
                  label="Latitudine"
                />
              </Grid>
              <Grid
                item
                xs={12}
              >
                <SpTextInput
                  enabled={false}
                  inputRef={register}
                  name="lat"
                  label="Longitudine"
                />
              </Grid>
            </div>
            <Grid
              item
              xs={12}
            >
              <SpTextInput
                inputRef={register}
                name="video_url"
                onChange={(e) => setCurrentVideoURL(e.target.value)}
                label="Video presentazione"
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <SpText
                variant="formText"
                style={{ marginTop: 10 }}
              >
                Anteprima video
              </SpText>
              <ReactPlayer
                style={{ border: '1px solid', borderColor: theme.colors.mainGreen }}
                url={currentVideoURL}
                onError={(e) => console.log(e)}
                on={(e) => console.log(e)}
                config={{
                  youtube: {
                    playerVars: { showinfo: 1 }
                  },
                  facebook: {
                    appId: '12345'
                  }
                }}
              />
            </Grid>
            {error && <SpText variant="h4ComponentLabelError">{error}</SpText>}
            {!openPointEdit.data?.id && (
              <Grid
                item
                container
                xs={12}
                alignItems={'flex-start'}
              >
                <SpButton
                  text={'Salva'}
                  buttonType="accept"
                  type="submit"
                />
              </Grid>
            )}
          </Grid>
        </form>
      </SpDialog>
    </>
  );
};
export default compose(withSnackbar, withRouter)(PointOfInterest);
